import { jsxs as m, jsx as i } from "react/jsx-runtime";
import { useTheme as r } from "./index.es190.js";
import { TooltipIcon as e } from "./index.es162.js";
import { FlexContainer as s } from "./index.es584.js";
const g = ({ children: p, start: o, end: t }) => {
  const l = r().spacings;
  return /* @__PURE__ */ m(s, { alignItems: "center", gap: l.s, width: "100%", children: [
    !!(o != null && o.type) && /* @__PURE__ */ i(e, { testId: "start", ...o, title: o.title || o.tooltip }),
    p,
    !!(t != null && t.type) && /* @__PURE__ */ i(e, { testId: "end", ...t, title: t.title || t.tooltip })
  ] });
};
export {
  g as CellAdditionalInfoWrapper
};
//# sourceMappingURL=index.es731.js.map
